<form (ngSubmit)="requestReset()" [formGroup]="form">
  <div class="pb-2">
    <div class="form-group">
      <py-reactive-form-input-field
        [group]="form"
        [label]="'password.forgotten.email_heading' | cxTranslate"
        [resettable]="true"
        fieldName="email"
        inputType="email"
        (enterEvent)="requestReset()"
        (handleReset)="onResetInput('email')"
      ></py-reactive-form-input-field>
    </div>
  </div>

  <py-action-button
    [success]="success$ | async"
    [error]="error$ | async"
    [loading]="loading$ | async"
    [type]="'submit'"
    [buttonLabel]="'username.forgotten.submit_action' | cxTranslate"
    [disabled]="form.invalid || !form.dirty"
    [buttonClass]="'btn btn-primary w-100 animated'"
    [spinnerType]="'dark'"
    (click)="requestReset()"
  >
  </py-action-button>
</form>
